module.exports = __webpack_public_path__ + "static/media/promo.548f66cb.webp";